<template>
    <el-container>
        <td-permission :permissions="permissionsView">
            <div slot="havePermission">
                <el-aside class="aside-classify-tree">
                    <td-tree
                        :lazyloading="lazyloading"
                        :draggable="draggable"
                        :isDbClick="true"
                        :calInternal="true"
                        :isClick="true"
                        :imgloading="true"
                        :typeContent="typeContent"
                        :checkStrictly="false"
                        ref="TdTree"
                        @onDbClick="onClick"
                        @onClick="onClick"
                        :checkNodes="checkNodes"
                        :showBox="false"
                        :dragLevel="true"
                        :isPaging="true"
                        :parentOrgIds="parentOrgId"
                        :orgIds="orgIds"
                        :sCodes="sCodes"
                        :orgTypeIds="orgTypeIds"
                        :defaultProps="defaultProps"
                        :nodeKey="nodeKey"
                        :isDistributed="false"
                        :interfaceName="interfaceName"
                        :inputShow="inputShow"
                        :params="params"
                        @nodeDrop="nodeDrop"
                    >
                    </td-tree>
                </el-aside>
            </div>
        </td-permission>
        <el-container>
            <el-header>
                <td-permission :permissions="permissionsView">
                    <div slot="havePermission">
                        <el-row :gutter="20" class="paddingLeft10 paddingTop10">
                            <p>{{ tableName }}</p>
                        </el-row>
                    </div>
                </td-permission>
                <el-form @submit.native.prevent :inline="true" :model="fromTrusteeship" ref="fromTrusteeship" v-if="tbFormVisible">
                    <td-permission :permissions="permissionsView">
                        <div slot="havePermission">
                            <el-form-item :label="$t('pgCommon.TABLE_NAME')" prop="sTableName">
                                <td-input v-model="fromTrusteeship.sTableName"></td-input>
                            </el-form-item>
                        </div>
                    </td-permission>
                    <el-form-item class="paddingLeft10">
                        <td-button type="primary" :permissions="permissionsView" :loading="loadingTb" @click="btnTbQuery" @keyup.enter.native="btnTbQuery">{{ $t('pgCommon.QUERY') }}</td-button>
                        <td-button type="button" :permissions="permissionsAdd" @click="btnAddTrusteeship">{{ $t('pgCommon.ADD_TRUSTEESHIP') }}</td-button>
                        <td-button type="button" :permissions="permissionsDel" :loading="loadingDel" @click="btnDeleteTrusteeship">{{ $t('pgCommon.STOP_TRUSTEESHIP') }}</td-button>
                        <td-button type="button" :permissions="permissionsSync" :loading="loadingSync" @click="btnSyncTrusteeship">{{ $t('pgCommon.BATCH_SYNC') }}</td-button>
                    </el-form-item>
                </el-form>
                <el-form @submit.native.prevent :inline="true" :model="fromColumn" ref="fromColumn" v-if="clFormVisible">
                    <td-permission :permissions="permissionsView" style="display:auto;">
                        <div slot="havePermission">
                            <el-form-item :label="$t('pgCommon.COLUMN_NAME')" prop="sColumnName">
                                <td-input v-model="fromColumn.sColumnName"></td-input>
                            </el-form-item>
                        </div>
                    </td-permission>
                    <el-form-item class="paddingLeft10">
                        <td-button type="primary" :permissions="permissionsView" :loading="loadingCl" @click="btnClQuery" @keyup.enter.native="btnClQuery">{{ $t('pgCommon.QUERY') }}</td-button>
                    </el-form-item>
                </el-form>
            </el-header>
            <el-main style="padding-top:0px;">
                <td-permission :permissions="permissionsView" style="width:100%">
                    <div slot="havePermission">
                        <!-- 加载托管表表格 -->
                        <td-table
                            v-if="tableVisible"
                            :columns="tbColumns"
                            :dataSource="tableData"
                            :pageSize="pageSizeTb"
                            :currentPage="currentPageTb"
                            :total="totalTb"
                            :rowKey="sId"
                            @handleSizeChange="handleSizeChangeTb"
                            @currentChange="currentChangeTb"
                            ref="tableInfo"
                        ></td-table>
                        <!-- 加载托管字段表格 -->
                        <td-table
                            v-if="columnVisible"
                            :columns="clColumns"
                            :dataSource="columnData"
                            :pageSize="pageSizeCl"
                            :currentPage="currentPageCl"
                            :total="totalCl"
                            @handleSizeChange="handleSizeChangeCl"
                            @currentChange="currentChangeCl"
                            ref="columnInfo"
                        ></td-table>
                    </div>
                </td-permission>
                <dialog-trusteeship
                    v-if="dialogTrusteeshipVisible"
                    :dialogTrusteeshipVisible="dialogTrusteeshipVisible"
                    :editItem="editItem"
                    :columnList="columnList"
                    :title="title"
                    v-on:edtTbOnSuccess="edtTbOnSuccess"
                    @trusteeshipDialogClose="trusteeshipDialogClose"
                ></dialog-trusteeship>
                <dialog-trusteeshipAdd
                    v-if="dialogTrusteeshipAddVisible"
                    :dialogTrusteeshipAddVisible="dialogTrusteeshipAddVisible"
                    :treeNode="treeNode"
                    :title="title"
                    v-on:addOnSuccess="addOnSuccess"
                    @trusteeshipAddDialogClose="trusteeshipAddDialogClose"
                ></dialog-trusteeshipAdd>
                <dialog-column
                    v-if="dialogColumnVisible"
                    :dialogColumnVisible="dialogColumnVisible"
                    :editItemCl="editItemCl"
                    :EditInitWidgetDate="EditInitWidgetDate"
                    :title="title"
                    @columnDialogClose="columnDialogClose"
                ></dialog-column>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import trusteeshipApi from './assets/api.js';
import dialogTrusteeship from './components/dialogTrusteeship.vue';
import dialogColumn from './components/dialogColumn.vue';
import dialogTrusteeshipAdd from './components/dialogTrusteeshipAdd.vue';
export default {
    props: {
        treeList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        lazyloading: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        defaultProps: {
            type: Object,
            default: function() {
                return {
                    children: 'children',
                    label: 'sName',
                    id: 'sId',
                    imgName: 'sIcon'
                };
            }
        },
        imgloading: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        calInternal: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        typeContent: {
            type: Array,
            default: function() {
                return [];
            }
        },
        isClick: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        isDbClick: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        draggable: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        inputName: {
            type: String,
            default: function() {
                return 'component.PLEASE_ENTER_NAME';
            }
        },
        // 树形是否分页
        isPaging: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 搜索框是否显示
        inputShow: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        height: {
            type: Number,
            default: function() {
                return 800;
            }
        }
    },
    // 初始化渲染
    components: {
        'dialog-trusteeship': dialogTrusteeship,
        'dialog-trusteeshipAdd': dialogTrusteeshipAdd,
        'dialog-column': dialogColumn
    },
    mounted() {},
    // 定义数据
    data() {
        return {
            permissionsView: ['configTable:view'],
            permissionsAdd: ['configTable:add'],
            permissionsDel: ['configTable:del'],
            permissionsEdit: ['configTable:edit'],
            permissionsSync: ['configTable:sync'],
            tbFormVisible: true,
            tableVisible: true,
            clFormVisible: false,
            columnVisible: false,
            tableName: '未选择',
            nodeKey: 'sId',
            fromTrusteeship: {
                sTableName: ''
            },
            fromColumn: {
                sColumnName: ''
            },
            dialogTrusteeshipVisible: false,
            dialogTrusteeshipAddVisible: false,
            dialogColumnVisible: false,
            tableData: [],
            columnData: [],
            checkList: [],
            columnList: [],
            nowTreeItem: [], // 当前选中树形节点
            treePicture: {}, // 树形图标列表
            treeNode: {}, //树形选中节点信息
            editItem: {}, //选中行信息
            pageSizeTb: 10, // 每页条数
            currentPageTb: 1, // 当前页
            totalTb: 0, // 总条数
            loadingTb: false, // 按钮是否为加载状态
            loadingSync: false,
            loadingDel: false,
            editItemCl: {}, //选中行信息
            pageSizeCl: 10, // 每页条数
            currentPageCl: 1, // 当前页
            EditInitWidgetDate: {}, //初始化控件信息
            totalCl: 0, // 总条数
            loadingCl: false, // 按钮是否为加载状态
            tbColumns: [
                {
                    prop: 'sTableName',
                    label: 'pgCommon.TABLE_NAME'
                },
                {
                    prop: 'sTableNotes',
                    label: 'pgCommon.TABLE_NOTES'
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsSync, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.syncTrusteeship(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.SYNCHRONIZE')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnExit([params.row]);
                                        }
                                    }
                                },
                                this.$t('pgCommon.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.deleteTrusteeship(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.STOP_TRUSTEESHIP')
                            )
                        ]);
                    }
                }
            ],
            clColumns: [
                {
                    prop: 'sColumnName',
                    label: 'pgCommon.COLUMN_NAME'
                },
                {
                    prop: 'sColumnType',
                    label: 'pgCommon.TYPE'
                },
                {
                    prop: 'iPrimaryKey',
                    label: 'pgCommon.PRIMARY_KEY',
                    align: 'center',
                    tableWidth: '80',
                    render: (createElement, params) => {
                        if (params.row.iPrimaryKey === 1) {
                            return createElement('div', [
                                createElement('img', {
                                    style: {
                                        verticalAlign: 'middle'
                                    },
                                    attrs: {
                                        src: require('./assets/images/' + window.vue.$store.state.skin + '/pryKey.png')
                                    }
                                })
                            ]);
                        }
                    }
                },
                {
                    prop: 'iCanEmpty',
                    label: 'pgCommon.NOT_EMPTY',
                    align: 'center',
                    tableWidth: '80',
                    render: (createElement, params) => {
                        if (params.row.iCanEmpty === 0) {
                            return createElement('div', [
                                createElement('img', {
                                    style: {
                                        verticalAlign: 'middle'
                                    },
                                    attrs: {
                                        src: require('./assets/images/' + window.vue.$store.state.skin + '/notEmpty.png')
                                    }
                                })
                            ]);
                        }
                    }
                },
                {
                    prop: 'sColumnNotes',
                    label: 'pgCommon.COLUMN_NOTES'
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '60',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnColumnExit([params.row]);
                                        }
                                    }
                                },
                                this.$t('pgCommon.EDIT')
                            )
                        ]);
                    }
                }
            ],
            interfaceName: { query: '/setting/tableController/findTrusteeshipTree', search: '/setting/tableController/searchTreeQuery' },
            params: {
                currentPage: 1,
                needPage: true,
                pageSize: 50
            }
        };
    },
    methods: {
        // 树形点击事件
        onClick(item) {
            if (item == null) {
                return;
            }
            this.currentPageTb = 1;
            this.currentPageCl = 1;
            this.nowTreeItem = item;
            if (item.type === window.pgCommon.sType.database) {
                this.tbFormVisible = true;
                this.tableVisible = true;
                this.clFormVisible = false;
                this.columnVisible = false;
                this.tableName = item.sName;
                this.queryTbDataList();
            } else {
                this.tableName = item.sDatabaseName + ' > ' + item.sName + '(' + item.sTableName + ')';
                this.tbFormVisible = false;
                this.tableVisible = false;
                this.clFormVisible = true;
                this.columnVisible = true;
                this.queryClDataList();
            }
        },

        // 添加
        btnAddTrusteeship() {
            if (this.nowTreeItem.length === 0 || this.nowTreeItem.sIcon === 'table') {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT_DATABASE'), type: 'warning' });
                return;
            }
            this.title = this.$t('pgCommon.ADD_TRUSTEESHIP');
            this.dialogTrusteeshipAddVisible = true;
            this.treeNode = this.nowTreeItem;
        },

        // 查询托管表数据
        btnTbQuery() {
            this.loadingTb = true;
            this.queryTbDataList();
        },

        // 获取每页条数
        handleSizeChangeTb(pageSize) {
            this.pageSizeTb = pageSize;
            this.queryTbDataList();
        },

        // 获取当前页
        currentChangeTb(currentPage) {
            this.currentPageTb = currentPage;
            this.queryTbDataList();
        },

        // 获取查询参数
        getTbParam() {
            let queryVo = {
                needPage: true,
                pageNum: this.currentPageTb,
                pageSize: this.pageSizeTb
            };
            if (this.nowTreeItem != null && this.nowTreeItem.sId != null && this.nowTreeItem.sId !== '' && this.nowTreeItem.sId !== undefined) {
                queryVo.sDatabaseId = this.nowTreeItem.sId;
            }
            queryVo.sTableNotes = this.fromTrusteeship.sTableName;
            return queryVo;
        },

        // 查询列表信息
        queryTbDataList() {
            let param = this.getTbParam();
            trusteeshipApi.listTrusteeshipTables(JSON.stringify(param), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.loadingTb = false;
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('setting/tableController/listTrusteeshipTables', response.data.statusMessage);
                    this.loadingTb = false;
                    return;
                }
                this.tableData = response.data.content;
                this.totalTb = response.data.count;
                this.loadingTb = false;
            });
        },

        // 查询托管字段数据
        btnClQuery() {
            this.loadingCl = true;
            this.queryClDataList();
        },

        // 获取字段每页条数
        handleSizeChangeCl(pageSize) {
            this.pageSizeCl = pageSize;
            this.queryClDataList();
        },

        // 获取字段当前页
        currentChangeCl(currentPage) {
            this.currentPageCl = currentPage;
            this.queryClDataList();
        },

        // 获取字段查询参数
        getClParam() {
            let queryVo = {
                needPage: true,
                pageNum: this.currentPageCl,
                pageSize: this.pageSizeCl
            };
            if (this.nowTreeItem != null && this.nowTreeItem.sId != null && this.nowTreeItem.sId !== '' && this.nowTreeItem.sId !== undefined) {
                queryVo.sTrusteeshipId = this.nowTreeItem.sId;
            }
            queryVo.sColumnName = this.fromColumn.sColumnName;
            return queryVo;
        },

        // 查询字段列表信息
        queryClDataList() {
            let param = this.getClParam();
            trusteeshipApi.listColumnsByTrusteeshipId(JSON.stringify(param), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.loadingCl = false;
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('setting/tableController/listColumnsByTrusteeshipId', response.data.statusMessage);
                    this.loadingCl = false;
                    return;
                }
                this.columnData = response.data.content;
                this.totalCl = response.data.count;
                this.loadingCl = false;
            });
        },

        // 同步托管表
        syncTrusteeship(item) {
            let formData = new FormData();
            if (item == null || item.sId == null || item.sId === '' || item.sId === undefined) {
                return;
            }
            formData.append('sTrusteeshipId', item.sId);
            trusteeshipApi.syncTrusteeship(formData, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('setting/tableController/trusteeshipApi', response.data.statusMessage);
                    return;
                }
                this.$message({ showClose: true, message: this.$t('pgCommon.SYNC_SUCCESS'), type: 'success' });
            });
        },

        // 批量同步
        btnSyncTrusteeship() {
            let items = this.$refs.tableInfo.getSelectAllRows();
            if (items == null || items.length === 0) {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('pgCommon.SYNC_TACK_LONG_TIME_CONFIRM_CONTINUE'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            }).then(() => {
                this.loadingSync = true;
                let ids = [];
                for (let i = 0; i < items.length; i++) {
                    if ((items[i].sId != null && items[i].sId !== '') || items[i].sId !== undefined) {
                        ids.push(items[i].sId);
                    }
                }
                trusteeshipApi.batchSyncTrusteeship(JSON.stringify(ids), response => {
                    this.loadingSync = false;
                    if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                        return;
                    }
                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('setting/tableController/batchSyncTrusteeship', response.data.statusMessage);
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('pgCommon.SYNC_SUCCESS'), type: 'success' });
                    this.queryTbDataList();
                });
            });
        },

        // 编辑
        btnExit(item) {
            let queryVo = {};
            queryVo.sTrusteeshipId = item[0].sId;
            trusteeshipApi.listColumnsByTrusteeshipId(JSON.stringify(queryVo), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.loadingCl = false;
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('setting/tableController/listColumnsByTrusteeshipId', response.data.statusMessage);
                    this.loadingCl = false;
                    return;
                }
                this.columnList = response.data.content;
                this.editItem = item[0];
                this.title = 'pgCommon.EDIT_TRUSTEESHIP_TABLE';
                this.dialogTrusteeshipVisible = true;
            });
        },

        // 终止托管
        btnDeleteTrusteeship() {
            let items = this.$refs.tableInfo.getSelectAllRows();
            if (items == null || items.length === 0) {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            }).then(() => {
                this.loadingDel = true;
                let ids = [];
                for (let i = 0; i < items.length; i++) {
                    if ((items[i].sId != null && items[i].sId !== '') || items[i].sId !== undefined) {
                        ids.push(items[i].sId);
                    }
                }
                trusteeshipApi.deleteTrusteeship(JSON.stringify(ids), response => {
                    this.loadingDel = false;
                    if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                        return;
                    }
                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('setting/tableController/deleteTrusteeship', response.data.statusMessage);
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS'), type: 'success' });
                    this.queryTbDataList();
                    let deleteItems = [];
                    for (let i = 0; i < items.length; i++) {
                        let item = {};
                        item.parentId = items[i].sDatabaseId;
                        item.id = items[i].sId;
                        deleteItems.push(item);
                    }
                    // 更新树形节点
                    this.$refs.TdTree.editTreeNode(deleteItems, 'delete', '');
                });
            });
        },

        // 删除托管
        deleteTrusteeship(row) {
            if (row.sId == null || row.sId === '' || row.sId === undefined) {
                return;
            }
            this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            }).then(() => {
                let ids = [];
                ids.push(row.sId);
                trusteeshipApi.deleteTrusteeship(JSON.stringify(ids), response => {
                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('setting/tableController/deleteTrusteeship', response.data.statusMessage);
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS'), type: 'success' });
                    this.queryTbDataList();
                    let deleteItems = [];
                    let item = {};
                    item.parentId = row.sDatabaseId;
                    item.id = row.sId;
                    deleteItems.push(item);
                    // 更新树形节点
                    this.$refs.TdTree.editTreeNode(deleteItems, 'delete', '');
                });
            });
        },

        // 编辑字段信息
        btnColumnExit(item) {
            this.editItemCl = item[0];
            this.title = 'pgCommon.EDIT_COLUMN';
            trusteeshipApi.queryInitOptionsDetail(JSON.stringify(''), response => {
                if (response.status === window.vue.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.EditInitWidgetDate = response.data.content;
                        this.dialogColumnVisible = true;
                    } else {
                        this.$message({ showClose: true, message: this.$t('pgCommon.ERROR_MASTER_INIT_WIDGET_FAILED'), type: 'warning' });
                    }
                }
            });
        },

        // 编辑成功的回调
        edtTbOnSuccess(data) {
            this.$refs.TdTree.editTreeNode([{ parentId: data.sDatabaseId, id: data.sId }], 'modify', data.sTableNotes);
            // 重新查询
            this.queryTbDataList();
        },

        // 添加成功的回调
        addOnSuccess(dataList) {
            this.dialogTrusteeshipAddVisible = false;
            // 重新查询
            this.queryTbDataList();
            for (let i = 0; i < dataList.length; i++) {
                let deleteItems = [];
                let item = {};
                item.parentId = dataList[i].sDatabaseId;
                item.id = dataList[i].sId;
                deleteItems.push(item);
                this.$refs.TdTree.editTreeNode([{ parentId: null, id: this.treeNode.sId }], 'add', dataList[i]);
            }
        },

        // 获取树形数据
        queryTreeData(item) {
            // 初始化分页条件
            if (this.isPaging && item === null && item.currentPage === '' && item.currentPage === undefined) {
                item.currentPage = this.currentPage;
                item.pageSize = this.pageSize;
            }
            // 查询条件
            let queryParam = {
                needPage: this.isPaging,
                sDatabaseId: item.parentId
            };
            if (this.isPaging) {
                queryParam.pageNum = item.currentPage;
                queryParam.pageSize = item.pageSize;
            }
            trusteeshipApi.findTrusteeshipTree(JSON.stringify(queryParam), response => {
                if (response.status === window.vue.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$nextTick(function() {
                            if (item.parentId === '') {
                                // 初始化树形先加载图片
                                this.initTreeIcon(response.data.content);
                            } else {
                                // 树形赋值
                                this.$refs.TdTree.initData(response.data.content, this.checkList);
                            }
                        });
                        // 树形赋值
                        this.$refs.TdTree.initData(response.data.content, this.checkList);
                    }
                }
            });
        },

        // 初始化树形图标
        initTreeIcon(treeData) {
            let types = ['database', 'table'];
            for (let i = 0; i < types.length; i++) {
                const icon = types[i];
                this.treePicture[icon] = icon + '.png';
            }
            if (treeData !== undefined && treeData !== null && treeData.length > 0) {
                this.$refs.TdTree.initData(treeData, this.checkList);
            }
        },

        // 关闭表编辑页面
        trusteeshipDialogClose() {
            this.dialogTrusteeshipVisible = false;
            // 重新查询
            this.queryTbDataList();
        },

        // 关闭添加页面
        trusteeshipAddDialogClose() {
            this.dialogTrusteeshipAddVisible = false;
            // 重新查询
            this.queryTbDataList();
        },

        // 关闭字段编辑页面
        columnDialogClose() {
            this.dialogColumnVisible = false;
            // 重新查询
            this.queryClDataList();
        }
    }
};
</script>
<style></style>
